import React from 'react';

export interface RiskItem {
  name: string;
  severity: 'Critical' | 'High' | 'Medium' | 'Low';
  likelihood: 'Very High' | 'High' | 'Medium' | 'Low' | 'Very Low';
  description: string;
  mitigation: string;
  owner: string;
  risk_id?: string;
}

const SEV_BORDER: Record<string, string> = {
  Critical: 'border-red-200 bg-red-50',
  High: 'border-orange-200 bg-orange-50',
  Medium: 'border-amber-100 bg-amber-50/60',
  Low: 'border-emerald-200 bg-emerald-50',
};
const SEV_ACCENT: Record<string, string> = {
  Critical: 'bg-red-600', High: 'bg-orange-500', Medium: 'bg-amber-500', Low: 'bg-emerald-500',
};

export interface RiskCardProps {
  risk: RiskItem;
  index: number;
}

export const RiskCard: React.FC<RiskCardProps> = ({ risk, index }) => (
  <div className={`border rounded-xl p-5 ${SEV_BORDER[risk.severity] || 'border-[#e5e7eb] bg-white'}`}>
    <div className="flex items-start gap-3">
      <div className={`w-7 h-7 rounded-full text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 ${SEV_ACCENT[risk.severity] || 'bg-gray-400'}`}>{index + 1}</div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap mb-2">
          <span className="text-sm font-semibold text-[#18365E]">{risk.name}</span>
          <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full text-white ${SEV_ACCENT[risk.severity] || 'bg-gray-400'}`}>{risk.severity}</span>
          <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-[#18365E]/10 text-[#18365E]">{risk.likelihood} likelihood</span>
        </div>
        <p className="text-xs text-[#717182] leading-relaxed mb-3 whitespace-pre-wrap">{risk.description}</p>
        {risk.mitigation ? (
          <div className="bg-white/60 rounded-lg p-3 border border-black/5">
            <p className="text-[10px] font-semibold text-[#18365E] uppercase tracking-wide mb-1">Mitigation Strategy</p>
            <p className="text-xs text-[#717182] leading-relaxed whitespace-pre-wrap">{risk.mitigation}</p>
          </div>
        ) : null}
        <p className="text-[10px] text-[#717182] mt-2">Responsible Owner: <span className="font-semibold text-[#18365E]">{risk.owner}</span></p>
      </div>
    </div>
  </div>
);

export default RiskCard;
